import * as React from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from '@mui/material';
import {MESSAGE_TYPE} from '../../../../CodeMaster'
import {createIconWithLevel} from '../../../../styledComponents/adminPage/IconCreator'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'

interface DialogButtonParams {
    buttonLabel: string
    buttonHandler: (...params: any) => void
    buttonDisabled: boolean
    isDefault: boolean
}

interface DialogParams {
    title: string
    errorLevel: MESSAGE_TYPE
    message: string
    buttonProps: DialogButtonParams[]
}

/**
 * @type {DialogComponentProps} ダイアログコンポーネントのprops
 */
interface DialogComponentProps {
    /**
     * @type {DialogParams} ダイアログの各種パラメータ
     */
    params: DialogParams
    /**
     * @type {React.ReactNode} 入力フォームのコンポーネント
     */
    inputAreaComponent: React.ReactNode
    /**
     * @type {Boolean} 閉開(true：ダイアログを開く false: ダイアログを閉じる)
     */
    open: boolean
}

/**
 * 管理画面のダイアログコンポーネント
 * 入力フォームなどをダイアログ内で利用する場合に本コンポーネントを使用する
 * 上記以外の場合は、DialogComponentを使用すること
 *
 * @param {DialogComponentProps} props
 * @return {React.ReactNode} ダイアログコンポーネント
 */
export const NatAdminCommonDialogComponent: React.FC<DialogComponentProps> = props => {
    const {open, params} = props
    if (!params) {
        return null
    }
    return (<>
        <Dialog
            id={'pp-dialog'}
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
        >
            <DialogTitle id="alert-dialog-title">
                <LeftRowFlexContainer>{createIconWithLevel(params.errorLevel)}{params.title}</LeftRowFlexContainer>
            </DialogTitle>
            <DialogContent>
                <StyledDialogContentText id="alert-dialog-description">
                    {params.message}
                </StyledDialogContentText>
                {props.inputAreaComponent}
            </DialogContent>
            <DialogActions>
                {
                    params.buttonProps.map((buttonProp, index) => (
                        <Button
                            disabled={buttonProp.buttonDisabled}
                            key={index}
                            color="primary"
                            onClick={buttonProp.buttonHandler}
                        >
                            {buttonProp.buttonLabel}
                        </Button>
                    ))
                }
            </DialogActions>
        </Dialog>
    </>)
}
NatAdminCommonDialogComponent.displayName = 'NatAdminCommonDialogComponent'

const StyledDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    white-space: pre-wrap;
    margin-bottom: 25px;
      color: rgba(0, 0, 0, 0.87);
  }
  `
